import { Component, Input, OnInit } from '@angular/core';

export interface LoadPanelOption{
  visible?: boolean;
  message?: string;
  closeOnOutsideClick?: boolean;
    hideOnOutsideClick?: boolean; // new
  showPane?: boolean;
  ofPosition?: string;
  shadingColor?: string;
}

@Component({
    selector: 'app-load-panel',
    templateUrl: './load-panel.component.html',
    styleUrls: ['./load-panel.component.less'],
    standalone: false
})
export class LoadPanelComponent implements OnInit {

  private _option: Required<LoadPanelOption> = {
  visible: false,
  message: '',
  closeOnOutsideClick: false,
  hideOnOutsideClick: false,
  showPane: true,
  ofPosition: '',
  shadingColor: 'rgba(0,0,0,0.4)'
};
//W0001 - dxLoadPanel - 'closeOnOutsideClick' option is deprecated in 22.1. Use the 'hideOnOutsideClick' option instead. 
  constructor() { }

  // @Input() option:LoadPanelOption={
  //   visible:false,
  //   message:"",
  //   closeOnOutsideClick:false,
  //   shadingColor: 'rgba(0,0,0,0.4)'
  // };


 @Input() set option(value: LoadPanelOption | undefined) {
  // merge parent values on top of defaults
  this._option = {
    ...this._option,
    ...(value ?? {}),
    hideOnOutsideClick: value?.hideOnOutsideClick ?? value?.closeOnOutsideClick ?? false
  };
}

get option(): Required<LoadPanelOption> {
  return this._option;
}

ngOnInit(): void {
}

}
